'use client';

import '@ui5/webcomponents/dist/TreeItemCustom.js';
import { withWebComponent } from '@ui5/webcomponents-react-base';
/**
 * The `TreeItemCustom` represents a node in a tree structure, shown as a `List`.
 *
 * This is the item to use inside a `Tree`.
 * You can represent an arbitrary tree structure by recursively nesting tree items.
 *
 * You can use this item to put any custom content inside the tree item.
 *
 *
 *
 * __Note__: This is a UI5 Web Component! [Repository](https://github.com/SAP/ui5-webcomponents) | [Documentation](https://sap.github.io/ui5-webcomponents/)
 *
 * @since [1.9.2](https://github.com/SAP/ui5-webcomponents/releases/tag/v1.9.2) of __@ui5/webcomponents__.
 */
const TreeItemCustom = withWebComponent('ui5-tree-item-custom', ['accessibilityAttributes', 'accessibleName', 'additionalTextState', 'highlight', 'icon', 'tooltip', 'type'], ['expanded', 'hasChildren', 'hideSelectionElement', 'indeterminate', 'movable', 'navigated', 'selected'], ['content', 'deleteButton'], ['detail-click']);
TreeItemCustom.displayName = 'TreeItemCustom';
export { TreeItemCustom };